import { useMutation } from "@apollo/react-hooks";
import { useAsyncCallback } from 'react-use-async-callback';
import gql from "graphql-tag";
import { AsyncActionStatus } from '../../../shared/abstractStore';
import { AssessmentItemQuestionUpdateInput } from '../generated/globalTypes';
import { updateAssessmentItemQuestionMutation, updateAssessmentItemQuestionMutationVariables } from '../generated/updateAssessmentItemQuestionMutation';
import { assessmentItemQuestionFieldsFragment } from '../models/AssessmentItemQuestion';

/**
 * Get a callback to update a AssessmentItemQuestion in the store.
 */
export function useUpdateAssessmentItemQuestionCallback(): [(id: string, model: AssessmentItemQuestionUpdateInput) => Promise<void>, AsyncActionStatus] {
    const [mutationAction, { error }] = useMutation<updateAssessmentItemQuestionMutation, updateAssessmentItemQuestionMutationVariables>(
        gql`
            mutation updateAssessmentItemQuestionMutation ($model: AssessmentItemQuestionUpdateInput!) {
                updateAssessmentItemQuestion(model: $model) {
                    ...assessmentItemQuestionFields
                }
            }

            ${assessmentItemQuestionFieldsFragment}
        `
    );

    // Wrap the mutation in a standard callback.
    const [action, { isExecuting, errors: actionErrors }] = useAsyncCallback(async (id: string, model: AssessmentItemQuestionUpdateInput) => {
        const result = await mutationAction({ variables: { model: { ...model, id: id } } });
        if (result.errors && result.errors.length) {
            throw result.errors;
        }
    }, [mutationAction]);

    return [action, { isExecuting: isExecuting, errors: error ? error.message : actionErrors }];
}
